// src/components/UserMenuStyles.ts
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

/** Общий контейнер, оформленный как «капсула» */
export const UserMenuContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "10px 12px",
  borderRadius: "9999px", // сделать максимально скруглённым
  backgroundColor: theme.components?.select?.borderEnabled ,
  //borderRadius: '24px',
  // Можно добавить border, если нужно
  border: `1px solid ${theme.components.border || "#E5E7EB"}`,
  cursor: "default",
 // marginLeft: "15px"
}));

/** Текст (шрифт Inter 15px) */
export const HeaderText = styled(Typography)(({ theme }) => ({
  fontFamily: "Inter, sans-serif",
  fontWeight: 500,
  fontSize: "15px",
  lineHeight: "100%",
  letterSpacing: "0px",
  color: theme.palette.TextAndIcon.primaryBlackBlueEnabled,
  marginLeft: '5px'
}));

/** Кнопка со стрелкой (Caret), которая открывает меню */
export const ArrowButton = styled("button")(({ theme }) => ({
  background: "transparent",
  border: "none",
  padding: 0,
  //marginLeft: 8,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
 marginLeft: "28px",
 marginRight: 3,
 color: theme.palette.TextAndIcon.primaryBlackBlueEnabled,
  "&:hover svg": {
    // При наведении можно менять цвет или opacity
    opacity: 0.8
  }
}));
